// TermsOfService.js

export const TermsContent = () => {
  return `
    <h2>ShowingBooker Terms of Service</h2>

    <h3>1. Scheduling and Notice Requirements</h3>
    <p>All showings must be scheduled at least 24 hours in advance to ensure proper legal notification to all parties as required by applicable tenant protection laws. California Civil Code Section 1954 requires a minimum 24-hour notice before entering an occupied property.</p>

    <h3>2. Booking and Payment</h3>
    <p>All property tour bookings are subject to a flat rate fee of $10.00 which confirms your private tour time and date. This platform fee is non-refundable but bookings can be rescheduled with proper notice.</p>

    <h3>3. Service Fee Explanation</h3>
    <p>ShowingBooker is a professional technology platform that automates scheduling and compliance for real estate tours. The $10 platform fee is similar to fees charged by photography, virtual tour, and inspection scheduling services.</p>

    <h3>4. Questions About Fees</h3>
    <p>If you have concerns about the $10 platform fee, this property may not be the right fit for your client. The platform fee ensures proper scheduling, notification, and compliance with all applicable laws.</p>

    <h3>5. Payment Processing</h3>
    <p>The $10 charge is strictly a technology platform service fee. This fee covers:</p>
    <ul>
      <li>Automated scheduling system</li>
      <li>Legal compliance notifications</li>
      <li>Secure payment processing</li>
      <li>24/7 booking availability</li>
    </ul>

    <h3>6. Common Questions</h3>
    <p>How does payment work for the $10 booking fee?</p>
    <ul>
      <li>Fee is charged at time of booking</li>
      <li>Processed securely through Stripe</li>
      <li>Receipt provided immediately</li>
      <li>Booking confirmed instantly</li>
    </ul>
  `;
};

export default function TermsOfService() {
  return (
    <div className="terms-of-service">
      <div dangerouslySetInnerHTML={{ __html: TermsContent() }} />
    </div>
  );
}